import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { jwtDecode } from 'jwt-decode';
import { getAuthTokenKey } from '../utils/axiosInstance';

const PrivateRoute = ({ requiredRole }) => {
  const { isAuthenticated, loading, role } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    if (requiredRole && requiredRole.toLowerCase() === 'applicant') {
      return <Navigate to="/portal/login" />;
    }
    return <Navigate to="/login" />;
  }

  if (requiredRole) {
    const userRoleLower = (role || '').toLowerCase();
    const requiredRoleLower = requiredRole.toLowerCase();

    // Map 'community' role to 'user' requiredRole (as used in App.js for communities)
    const normalizedUserRole = userRoleLower === 'community' ? 'user' : userRoleLower;
    const normalizedRequiredRole = requiredRoleLower === 'community' ? 'user' : requiredRoleLower;

    if (normalizedUserRole !== normalizedRequiredRole) {
      if (normalizedRequiredRole === 'applicant') {
        return <Navigate to="/portal/login" />;
      }
      return <Navigate to="/login" />;
    }

    // Force new applicants to change password before accessing any other portal page
    if (normalizedRequiredRole === 'applicant' && location.pathname !== '/portal/change-password') {
      try {
        const token = localStorage.getItem(getAuthTokenKey());
        if (token) {
          const decoded = jwtDecode(token);
          if (decoded.mustChangePassword) {
            return <Navigate to="/portal/change-password" replace />;
          }
        }
      } catch (e) {
        // Invalid token — let other guards handle it
      }
    }
  }

  return <Outlet />;
};

export default PrivateRoute;